<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <CustodyExpenseForm
      v-if="!isLoading"
      :custodyExpense="custodyExpense"
      v-on:addOrUpdateCustodyExpense="addOrUpdateCustodyExpense()"
      :submitName="$t('edit')"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import CustodyExpenseForm from "@/components/settings/settingsOther/custodyExpenses/CustodyExpenseForm.vue";
import CustodyExpense from "@/models/settings/settingsOther/custodyExpenses/CustodyExpense";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    CustodyExpenseForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      custodyExpense: new CustodyExpense(),
    };
  },
  props: ["custodyExpenseToken"],
  methods: {
    async getCustodyExpenseDetails() {
      this.isLoading = true;
      this.custodyExpense.custodyExpenseToken = this.custodyExpenseToken;
      try {
        let response = await this.custodyExpense.getCustodyExpenseDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.custodyExpense.fillData(response.data.custodyExpenseData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.$router.push({ name: "CustodyExpenses" }).catch(() => {});
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.$router.push({ name: "CustodyExpenses" }).catch(() => {});
      }
      this.isLoading = false;
    },
    async addOrUpdateCustodyExpense() {
      this.isLoading = true;
      try {
        let response = await this.custodyExpense.addOrUpdateCustodyExpense(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push({ name: "CustodyExpenses" }).catch(() => {});
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getCustodyExpenseDetails();
  },
};
</script>
